import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Process from "@/components/Process";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import ServiceArea from "@/components/ServiceArea";
import BookingForm from "@/components/BookingForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";

function Home() {
  return (
    <div className="App" data-testid="page-home">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <Process />
        <Gallery />
        <Reviews />
        <ServiceArea />
        <BookingForm />
        <FAQ />
      </main>
      <Footer />
      <FloatingCTA />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#fff",
            border: "1px solid rgba(200,164,77,0.4)",
            borderRadius: "9999px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
